"use client"
import { Outlet } from "react-router-dom"
import { Box, Container, Paper, useTheme } from "@mui/material"
import Logo from "../components/brand/Logo"
import { motion } from "framer-motion"

const AuthLayout = () => {
  const theme = useTheme()

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "background.default",
        background: "linear-gradient(135deg, rgba(99, 102, 241, 0.05) 0%, rgba(244, 63, 94, 0.05) 100%)",
      }}
    >
      <Box
        sx={{
          py: 3,
          px: 3,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Logo />
      </Box>
      <Container
        maxWidth="sm"
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          py: 4,
        }}
      >
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
          <Paper
            elevation={0}
            sx={{
              p: 4,
              borderRadius: 3,
              boxShadow: "0px 4px 30px rgba(0, 0, 0, 0.08)",
              border: "1px solid rgba(0, 0, 0, 0.05)",
              background: "rgba(255, 255, 255, 0.95)",
              backdropFilter: "blur(10px)",
            }}
          >
            <Outlet />
          </Paper>
        </motion.div>
      </Container>
      <Box
        component="footer"
        sx={{
          py: 3,
          textAlign: "center",
          color: "text.secondary",
          fontSize: "0.875rem",
        }}
      >
        © {new Date().getFullYear()} TinyTrack. All rights reserved.
      </Box>
    </Box>
  )
}

export default AuthLayout

